import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

interface ProductCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const ProductCheckbox: React.FC<ProductCheckboxProps> = ({
  checked,
  onChange,
  className
}) => {
  return (
    <div
      className={classNames(
        'product-checkbox',
        { 'product-checkbox--checked': checked },
        className
      )}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
        onChange(!checked);
      }}
      role="checkbox"
      aria-checked={checked}
    >
      <div className="product-checkbox__inner">
        {checked && (
          <FontAwesomeIcon icon={faCheck} className="product-checkbox__icon" />
        )}
      </div>
    </div>
  );
};

export default ProductCheckbox;
